import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ActivationCodeModel } from '../models/activation-code.model';
import { ActivationModel } from '../models/activation.model';
import { UserFormModel } from '../models/user-form.model';
import { RegistrationValidationErrors } from '../responses/RegistrationValidationErrors';

const API_ENDPOINT = '/api/';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {

  public activation: ActivationModel = new ActivationModel();

  /**
   * Constructor
   * @param http The HttpClient
   */
  public constructor(private http: HttpClient) { }

  /**
   * Send the activation code
   * @param {ActivationCodeModel} activationCode
   *
   * @returns {Observable}
   */
  public sendActivationCode(activationCode: ActivationCodeModel): Observable<any> {
    return this.http.post(API_ENDPOINT + 'activation/code/send', activationCode).pipe(
      map((response: any) => {
        this.activation = response.items;
        return response.items;
      }),
      catchError((activationCodeError) => {
        return throwError(activationCodeError);
      }),
    );
  }

  /**
   * Save the User Form
   *
   * @param {ActivationCodeModel} activationCode
   * @param {UserFormModel} userForm
   *
   * @return {Observable}
   */
  public saveUserForm(activationCode: ActivationCodeModel, userForm: UserFormModel): Observable<any> {
    return this.http.post(API_ENDPOINT + 'registration/save', {activationCode: activationCode, userForm: userForm}).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((saveError: {error: {errors: RegistrationValidationErrors, message: {title: string, text: string}}}) => {
        return throwError(saveError.error);
      }),
    );
  }
}
